import React from 'react';
import background from '../../assets/keep-cool.jpg';
import ReusableInfoCard from '../../components/ReusableInfoCard/ReusableInfoCard';


class InfoKeepcool extends React.Component {
  render () { 
   return(
  
  <ReusableInfoCard             
    
        tag="TAKE ACTION"
        description="Keep Cool"
        paragraph="Staying cool is essential. Rising temperatures and increasing blackouts are raising the stakes."
        background={background}
     />
  
  );
 }
}   

export default InfoKeepcool;